import React from 'react';
import {Icon} from '../Icon/Icon';
import './styles.css';

interface Props {
  id: any;
  icon: string;
  title: string;
  onSelect: (id: any) => void;
  selected: boolean;
}

const FilterPill = React.memo(
  ({id, icon, title, selected, onSelect}: Props) => {
    return (
      <button
        className={`FilterPill ${selected ? 'FilterPillActive' : ''} ${
          !icon ? 'FilterAll' : ''
        }`}
        onClick={() => onSelect(id)}>
        {icon && <Icon name={icon} />}
        <p>{title}</p>
      </button>
    );
  },
);

export default FilterPill;
